import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import Styles from './sidebar-styles.scss';
import { Link, useLocation } from 'react-router-dom';
function StringTo_(text) {
    return text.toLowerCase().replace(/\s/g, '_');
}
function stringToSubId(item) {
    return item === null || item === void 0 ? void 0 : item.path.toLowerCase().replace(/\//g, '_');
}
const Sidebar = ({ items }) => {
    const { pathname } = useLocation();
    const [expandedItem, setExpandedItem] = useState(null);
    const getRoutes = (itemParam, subItemClassText) => {
        return itemParam.map((item, key) => {
            var _a;
            if (item.hideSidebar)
                return;
            const isSelected = (item === null || item === void 0 ? void 0 : item.path) === pathname;
            const isExpanded = item.label === expandedItem;
            if (item.subItems) {
                return (React.createElement("div", { key: `root_${StringTo_(item.label)}_${key}` },
                    React.createElement("a", { href: `#collapse_${StringTo_(item.label)}`, "data-bs-parent": "#sidebar", className: classNames('list-group-item border-end-0 d-inline-block text-truncate dropdown-toggle', Styles.menuItem), "aria-expanded": isExpanded, "aria-controls": `collapse_${StringTo_(item.label)}`, role: "button", "data-bs-toggle": "collapse", id: `id_${StringTo_(item.label)}`, onClick: () => setExpandedItem(isExpanded ? null : item.label) },
                        item.icon && React.cloneElement(item.icon, { color: isSelected ? '#00A3FF' : '#454957' }),
                        ' ',
                        React.createElement("span", null, item.label)),
                    React.createElement("div", { className: classNames('collapse', { show: isExpanded }), id: `collapse_${StringTo_(item.label)}` }, getRoutes(item.subItems, Styles.subItemClassText))));
            }
            return (React.createElement(Link, { key: `${item.path}_${key}`, to: item.path, "data-bs-parent": "#sidebar", className: classNames('list-group-item border-end-0 d-inline-block text-truncate', isSelected ? Styles.menuItemSelected : Styles.menuItem, item.lastIndex ? Styles.isLast : ''), onClick: () => setExpandedItem(item.label), style: { bottom: item.lastIndex ? (_a = item.lastIndexBottom) !== null && _a !== void 0 ? _a : '1.25rem' : 'unset' }, id: `id_sb_${stringToSubId(item)}` },
                React.createElement("div", { className: subItemClassText },
                    item.icon && React.cloneElement(item.icon, { color: isSelected ? '#00A3FF' : '#454957' }),
                    ' ',
                    React.createElement("span", null, item.label))));
        });
    };
    // Update the useEffect hook to set the expandedItem state to the parent item's label when a subitem is selected
    useEffect(() => {
        const selectedItem = items.find(item => { var _a; return (_a = item.subItems) === null || _a === void 0 ? void 0 : _a.some(subItem => subItem.path === pathname); });
        if (selectedItem) {
            setExpandedItem(selectedItem.label);
        }
    }, [pathname, items]);
    return (React.createElement("div", { className: Styles.sidebar, id: "sidebar-menu-left" },
        React.createElement("div", { className: Styles.content }, getRoutes(items, null))));
};
export default Sidebar;
